import { generateObjectId } from "../../objectIdUtils";

const BUTTON = {
  name: "Button",
  type: "button",
  icon: "",
  action_start: {
    show: [],
    hide: [],
    refresh: []
  },
  action_end: {
    show: [],
    hide: [],
    refresh: []
  },
  job_id: "",
  params: {},
  job_config_id: "",
  job_template: "",
  display_logic: {
    logics: []
  }
};

const DROPDOWN = {
  name: "Dropdown",
  type: "dropdown",
  icon: "",
  action_start: {
    show: [],
    hide: [],
    refresh: []
  },
  action_end: {
    show: [],
    hide: [],
    refresh: []
  },
  action_call_onchange: true,
  job_id: "",
  params: {},
  job_config_id: ""
};

const TIMELINE = {
  type: "timeline",
  display: "Timeline",
  id: "timeline"
};

const SECTION = {
  type: "section",
  display: "Section",
  config: { layouts: [] },
  collapse: false,
  height: ""
};

const SPACER = {
  type: "spacer",
  display: "Spacer",
  height: 50
};

const BUTTON_GROUP = {
  type: "button-group",
  display: "Button Group",
  button_list: []
};

const FORM = {
  type: "form",
  name: "Form",
  config: BUTTON
};

const MAIL_THREAD = {
  display: "Mail Thread",
  type: "mail_thread"
};
const FILE_VIEWER = {
  display: "File Viewer",
  type: "file_viewer",
  preview_field: ""
};
const FILE_PREVIEW = {
  display: "File Viewer",
  type: "file_preview",
  preview_field: ""
};
const SEPARATOR = {
  display: "Separator",
  type: "separator",
  direction: "horizontal"
};

const TABVIEW = {
  type: "tabview",
  display: "Tabview",
  config: { headerData: [], bodyData: {} },
  vertical: false
};

const TABLEVIEW = {
  type: "tableview",
  display: "Tableview",
  config: {
    headerData: ["Header", "Header"],
    bodyData: [
      [
        {
          data: "",
          data_key: "",
          data_type: "text",
          icon: ""
        },
        {
          data: "",
          data_key: "",
          data_type: "text",
          icon: ""
        }
      ],
      [
        {
          data: "",
          data_key: "",
          data_type: "text",
          icon: ""
        },
        {
          data: "",
          data_key: "",
          data_type: "text",
          icon: ""
        }
      ],
      [
        {
          data: "",
          data_key: "",
          data_type: "text",
          icon: ""
        },
        {
          data: "",
          data_key: "",
          data_type: "text",
          icon: ""
        }
      ]
    ]
  },
  border: false,
  header: true,
  table_type: ""
};

const HTML = {
  type: "html",
  display: "HTML",
  content: ""
};

const DYNAMIC_HTML = {
  type: "dynamic-html",
  display: "Dynamic HTML",
  content: "",
  target_actions: {}
};

const CUSTOM_COMPONENT = {
  type: "custom-component",
  name: "Custom Component",
  config: {
    props: []
  }
};

const VARIABLE = {
  type: "variable",
  name: "Variable",
  custom_js: ""
};

const EMPTY = {
  type: "empty",
  display: "empty field"
};

const LABEL = {
  type: "label",
  name: "Label"
};

const IMAGE = {
  type: "image",
  name: "Image",
  source: "",
  repo_source: ""
};
const PROGRESS_TRACKER = {
  type: "progress-tracker",
  name: "Progress Tracker",
  total_value: "",
  completed_value: "",
  view_type: "linear",
  title: "",
  color: "",
  format: "percentage"
};

const DROPDOWN_NAVIGATE = {
  type: "dropdown-navigate",
  data_id: "",
  data_type: "",
  page: "",
  mapping: [],
  prefilter: [],
  prefilters_joined_by: "",
  label: "",
  button: {
    name: "",
    icon: ""
  },
  display_field: []
};

const FIELD = {
  display: "field",
  type: "field",
  field_type: "",
  data_type: "",
  id: ""
};
const IMAGE_FIELD = {
  display: "field",
  type: "field",
  field_type: "image",
  data_type: "image",
  id: "",
  image_placeholder: {
    source: "",
    repo_source: ""
  }
};

const ICON = {
  type: "icon",
  name: "Icon",
  icon_class: "home_filled e9b2"
};

const PROGRESS_BAR = {
  display: "",
  icon: "",
  type: "progress-bar"
};
const RV_TILE = {
  type: "rv_tile",
  title: "Tile",
  aggregate_column: "",
  aggregate_config: {
    operator: "",
    group_by_column: ""
  },
  icon: "",
  aggregate_function: "",
  format_type: "",
  custom_css: "",
  custom_id: "",
  custom_classname: ""
};

const RV_CHART = {
  type: "rv_chart",
  dimension: "",
  title: "New Chart",
  sub_title: "",
  chart_type: "",
  data_label: "",
  data_title: "",
  xaxis_title: "",
  yaxis_title: "",
  group_columns: [],
  aggregate_column: "",
  aggregate_function: "",
  axis_inverted: false,
  add_event_config: {},
  tile_aggregate_function: "",
  chart_styles: {}
};
const CHART = {
  type: "chart",
  dimension: "",
  title: "New Chart",
  sub_title: "",
  chart_type: "",
  data_label: "",
  data_title: "",
  xaxis_title: "",
  yaxis_title: "",
  group_columns: [],
  aggregate_column: "",
  aggregate_function: "",
  axis_inverted: false,
  add_event_config: {},
  tile_aggregate_function: "",
  chart_styles: {}
};

const RV_FILTERS = {
  type: "rv_filters",
  name: "Filters",
  layout: "horizontal",
  filters: [],
  icon: "filter_alt ef4f"
};

const RV_TAB_FILTERS = {
  type: "rv_tab_filters",
  placeholder: [
    { id: generateObjectId(), label: "Male" },
    { id: generateObjectId(), label: "Female" },
    { id: generateObjectId(), label: "Other" }
  ],
  filter_field: null
};

const RV_TABLE = {
  type: "rv_table",
  columns: [],
  layout_type: "table_view",
  catalog: {
    layout: [
      {
        id: generateObjectId(),
        type: "section",
        style: { width: "100%", height: "120px", position: "relative" },
        classes: [],
        children: []
      }
    ],
    cards_per_row: 1,
    gap_between_cards: 18
  }
};

// for positioned/WYSIWYG screen
const TABLE = {
  type: "table",
  config: {
    columns: [
      {
        cell_id: generateObjectId(),
        title: "Name"
      },
      {
        cell_id: generateObjectId(),
        title: "Age"
      },
      {
        cell_id: generateObjectId(),
        title: "Country"
      }
    ],
    rows: [
      [
        { cell_id: generateObjectId(), custom_text: "John Doe" },
        { cell_id: generateObjectId(), custom_text: "25" },
        { cell_id: generateObjectId(), custom_text: "USA" }
      ],
      [
        { cell_id: generateObjectId(), custom_text: "Jane Smith" },
        { cell_id: generateObjectId(), custom_text: "30" },
        { cell_id: generateObjectId(), custom_text: "Canada" }
      ],
      [
        { cell_id: generateObjectId(), custom_text: "Peter Brown" },
        { cell_id: generateObjectId(), custom_text: "28" },
        { cell_id: generateObjectId(), custom_text: "UK" }
      ]
    ]
  },
  options: {
    show_border: false,
    show_header: true,
    table_style: "default"
  }
};

const SEARCH_BOX = {
  type: "search_box",
  placeholder: "Search...",
  action_call_onchange: true
};

const COLUMNS_MANAGER = {
  type: "rv_columns_manager",
  title: "Manage Columns",
  icon: "list e896"
};

const DOWNLOAD_FILE = {
  type: "download_file",
  file_type: "excel",
  title: "Download File",
  icon: "download f090"
};

const RV_TABLE_CATALOG_TOGGLER = {
  type: "rv_table_catalog_toggler",
  table: {
    title: "Table View",
    icon: "table_rows_narrow f73f"
  },
  catalog: {
    title: "Catalog View",
    icon: "cards e991"
  }
};

const RV_ACTION_BUTTON = {
  ...BUTTON,
  type: "rv_action_button"
};

const RV_ACTION_DROPDOWN = {
  ...DROPDOWN,
  type: "rv_action_dropdown"
};
const RV_ACTIONS_LIST = {
  type: "rv_actions_list",
  actions: [],
  icon: "more_vert e5d4"
};

const CHART_TILE = {
  type: "chart_tile",
  title: "Tile",
  aggregate_column: "",
  aggregate_config: {
    operator: "",
    group_by_column: ""
  },
  icon: "",
  aggregate_function: "",
  format_type: "",
  custom_css: "",
  custom_id: "",
  custom_classname: ""
};

const CHART_FILTERS = {
  type: "chart_filters",
  name: "Filters",
  layout: "horizontal",
  filters: [],
  icon: "filter_alt ef4f"
};

const MAP = {
  type: "map",
  card: {
    layout: [
      {
        id: generateObjectId(),
        type: "section",
        style: { width: "100%", height: "120px", position: "relative" },
        classes: [],
        children: []
      }
    ]
  },
  location_point: "",
  card_width: 250
};

const DV_GROUP = {
  type: "dv-group",
  display: "DV Group",
  logic_type: "state_base",
  field_id: "",
  default_dv_id: "",
  dv_list: []
};

const JSON_TO_TABLE = {
  type: "json_to_table",
  json_field: "",
  columns_path: "",
  columns: [
    {
      id: generateObjectId(),
      value_path: "path",
      header_name: "Name",
      placeholder: "John Doe",
      field_type: "varchar"
    }
  ]
};

const elementConfig = {
  button: BUTTON,
  dropdown: DROPDOWN,
  timeline: TIMELINE,
  section: SECTION,
  spacer: SPACER,
  "button-group": BUTTON_GROUP,
  form: FORM,
  mail_thread: MAIL_THREAD,
  file_viewer: FILE_VIEWER,
  file_preview: FILE_PREVIEW,
  separator: SEPARATOR,
  tabview: TABVIEW,
  tableview: TABLEVIEW,
  html: HTML,
  "dynamic-html": DYNAMIC_HTML,
  empty: EMPTY,
  field: FIELD,
  label: LABEL,
  image: IMAGE,
  variable: VARIABLE,
  "progress-tracker": PROGRESS_TRACKER,
  "custom-component": CUSTOM_COMPONENT,
  "dropdown-navigate": DROPDOWN_NAVIGATE,
  image_field: IMAGE_FIELD,
  icon: ICON,
  "progress-bar": PROGRESS_BAR,
  rv_tile: RV_TILE,
  rv_chart: RV_CHART,
  chart: CHART,
  rv_filters: RV_FILTERS,
  rv_table: RV_TABLE,
  table: TABLE,
  search_box: SEARCH_BOX,
  rv_columns_manager: COLUMNS_MANAGER,
  download_file: DOWNLOAD_FILE,
  rv_action_button: RV_ACTION_BUTTON,
  rv_action_dropdown: RV_ACTION_DROPDOWN,
  rv_table_catalog_toggler: RV_TABLE_CATALOG_TOGGLER,
  rv_actions_list: RV_ACTIONS_LIST,
  rv_tab_filters: RV_TAB_FILTERS,
  chart_tile: CHART_TILE,
  chart_filters: CHART_FILTERS,
  map: MAP,
  "dv-group": DV_GROUP,
  json_to_table: JSON_TO_TABLE
};

export { elementConfig };
